/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  settingsDrawerOpen: false,
  activeSettingsTab: 'INDIAN SELLER COMMISSION', // Default tab
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openSettingsDrawer: (state) => {
      state.settingsDrawerOpen = true;
    },
    closeSettingsDrawer: (state) => {
      state.settingsDrawerOpen = false;
    },
    toggleSettingsDrawer: (state) => {
      state.settingsDrawerOpen = !state.settingsDrawerOpen;
    },
    setActiveSettingsTab: (state, action) => {
      state.activeSettingsTab = action.payload;
    },
    openSettingsWithTab: (state, action) => {
      state.settingsDrawerOpen = true;
      state.activeSettingsTab = action.payload;
    },
  },
});

export const {
  openSettingsDrawer,
  closeSettingsDrawer,
  toggleSettingsDrawer,
  setActiveSettingsTab,
  openSettingsWithTab,
} = uiSlice.actions;

export default uiSlice.reducer;
